var map = {
	"./3GoVideo.png": 979,
	"./bienvenida.webp": 750,
	"./campamento-xr.webp": 287,
	"./colivri-404-page.png": 132,
	"./colivri-iso.png": 977,
	"./ejercito.png": 758,
	"./logo.png": 796,
	"./meta.png": 462,
	"./navbar.png": 991,
	"./openlab.jpg": 940,
	"./openlab.webp": 422,
	"./slider.webp": 90,
	"./unity.png": 566,
	"./vr.png": 693,
	"./vr.webp": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;